"use client";

import { useStrictLocalization } from "@faire/web/common/localization";
import { MessengerStore } from "@faire/web/messenger/store/MessengerStore";
import { useEffect } from "react";

import { ChatBubbleGlobalUI } from "./packages/messenger/store/ChatBubbleGlobalUI";
import { MarketStore } from "./stores/domain/Events/FaireMarkets/MarketStore";
import { SSOStore } from "./stores/domain/SSOStore";
import { UserStore } from "./stores/domain/UserStore";
import { MessengerFactory } from "./stores/MessengerFactory";
import { UserMessengerStore } from "./views/messages/UserMessengerStore";

/**
 * Runs once Providers have been initialized.
 */
export const useInitializeLocalization = () => {
  const { strictLocalize } = useStrictLocalization();

  useEffect(() => {
    SSOStore.get().setStrictLocalize(strictLocalize);
  }, [strictLocalize]);

  useEffect(() => {
    MarketStore.get().setStrictLocalize(strictLocalize);
  }, [strictLocalize]);

  useEffect(() => {
    const user = UserStore.get().user;
    const messengerStore = new MessengerStore(user, strictLocalize);
    if (user) {
      messengerStore.init(user, undefined);
    }
    MessengerFactory.get().messengerStore = messengerStore;
    MessengerFactory.get().chatBubbleGlobalUI = new ChatBubbleGlobalUI(
      messengerStore
    );
    UserMessengerStore.get().messengerStore = messengerStore;
  }, [strictLocalize]);
};
